
import React from "react";
import clsx from "clsx";

export function Button({ asChild = false, className = "", size = "md", children, ...props }) {
    const base =
        "inline-flex items-center justify-center font-medium rounded-xl transition focus:outline-none focus:ring-2 focus:ring-offset-2";

    const sizes = {
        sm: "px-3 py-1.5 text-sm",
        md: "px-4 py-2 text-sm",
        lg: "px-5 py-2.5 text-base"
    };

    const variants = "bg-violet-600 text-white hover:bg-violet-700 focus:ring-violet-500";

    if (asChild) {
        // for <Button asChild><a>…</a></Button>
        return React.cloneElement(children, {
            className: clsx(base, sizes[size], variants, className, children.props.className),
            ...props
        });
    }

    return (
        <button className={clsx(base, sizes[size], variants, className)} {...props}>
            {children}
        </button>
    );
}
